/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Globals from "../shared/Globals";
import { qreq } from "../shared/qrequest";
import BaseCom from "./BaseCom";
import Icon from "./Icon";
import Tick from "./Tick";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { Dropdown } from "react-bootstrap";

class AlertIcon extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            unread: 0,
            list: []
        };
        this.tick = this.tick.bind(this);
        this.click = this.click.bind(this);
        this.readAll = this.readAll.bind(this);
    }

    componentDidMount() {
        this.tick();
    }

    tick() {
        qreq.get('/api/alert/list', j => {
            if(j.list)
                this.setState({ list: j.list, unread: j.totalCount });
        });
    }

    click(item) {
        qreq.post('/api/alert/read', {...item});
        this.props.navigate(item.linkHref);
        item.isRead = true;
        this.setState({ list: [...this.state.list] });
    }

    readAll() {
        qreq.post('/api/alert/read/all', {}, j => {
            if(j.errorCode === 0) {
                var list = [...this.state.list];
                list.forEach(i => i.isRead = false);
                this.setState({ list: list });
            }
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    render() {
        return <>
            <Tick onTick={this.tick} interval={10000} />
            <Dropdown className="ms-2 no-arrow">
                <Dropdown.Toggle variant={this.state.unread > 0 ? 'warning' : 'secondary'}>
                    <Icon icon="faBell" />
                    {this.state.unread > 0 ? <span className="ms-1">{this.state.unread}</span> : null}
                </Dropdown.Toggle>
                <Dropdown.Menu variant="dark" style={{maxHeight: '80vh', overflow: 'auto'}}>
                    {this.state.list.length === 0 ? <Dropdown.Item>No alerts.</Dropdown.Item> : this.state.list.map(i => <Dropdown.Item key={i.id} onClick={i.linkHref ? () => this.click(i) : null}>
                        {!i.isRead ? <Icon icon="faEnvelope" className="me-2 text-warning" /> : null}
                        <small>{Globals.toMDYHMLocalDateString(i.createdDate)}</small>
                        <p>{i.message}</p>
                    </Dropdown.Item>)}
                    {this.state.unread > 0 ? <Dropdown.Item onClick={this.readAll}><i>Mark All as Read</i></Dropdown.Item> : null}
                </Dropdown.Menu>
            </Dropdown>
        </>;
    }
}

export default withParamsAndNavigate(AlertIcon);